/** Haptics + short confetti bursts for Telegram Mini App */

export function haptic(kind = 'light') {
  try {
    const hf = window.Telegram?.WebApp?.HapticFeedback;
    if (!hf) return;
    if (kind === 'success' || kind === 'error' || kind === 'warning') {
      hf.notificationOccurred?.(kind === 'success' ? 'success' : kind === 'error' ? 'error' : 'warning');
    } else if (kind === 'medium' || kind === 'heavy') {
      hf.impactOccurred?.(kind);
    } else {
      hf.impactOccurred?.('light');
    }
  } catch (_) {
    /* ignore */
  }
}

export function burstConfetti({ count = 48, duration = 1200 } = {}) {
  if (typeof document === 'undefined') return;
  // Cap concurrent layers so rapid celebrates don't stack forever
  const existing = document.querySelectorAll('.confetti-layer');
  if (existing.length >= 2) existing[0].remove();
  const root = document.createElement('div');
  root.className = 'confetti-layer';
  root.setAttribute('aria-hidden', 'true');
  const colors = ['#ff6b35', '#ffd166', '#ef476f', '#e85d04', '#f4a261', '#e9c46a', '#ff9f43', '#fff3'];
  for (let i = 0; i < count; i += 1) {
    const p = document.createElement('i');
    const x = 15 + Math.random() * 70;
    const delay = Math.random() * 180;
    const rot = Math.random() * 360;
    const w = 10 + Math.random() * 14;
    const h = 12 + Math.random() * 16;
    p.style.cssText = [
      `left:${x}%`,
      `width:${w}px`,
      `height:${h}px`,
      `background:${colors[i % colors.length]}`,
      `animation-delay:${delay}ms`,
      `animation-duration:${0.9 + Math.random() * 0.55}s`,
      `transform:rotate(${rot}deg)`,
      `--dx:${(Math.random() - 0.5) * 280}px`,
      `--dy:${120 + Math.random() * 320}px`,
    ].join(';');
    root.appendChild(p);
  }
  document.body.appendChild(root);
  window.setTimeout(() => {
    root.remove();
  }, duration + 400);
}

export function celebrate(kind = 'level') {
  if (typeof window !== 'undefined' && window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) {
    haptic('success');
    return;
  }
  haptic('success');
  burstConfetti({
    count: kind === 'league' ? 72 : 52,
    duration: kind === 'league' ? 1400 : 1100,
  });
}
